import { ButtonLink } from 'components/styles_components/link';
import { SidebarToggleButton, SidebarToggleWrapper, StyledAppBar } from 'components/styles_components/menu';
import { TopMenuTitleTypography } from 'components/styles_components/typography';
import { Box, Container, IconButton, Toolbar } from 'components/ui';
import { ProbelistMenuHideIcon, ProbelistMenuShowIcon } from 'components/uiIcons';
import { useMenu } from 'contexts/menu';
import { FormattedMessage, useIntl } from 'react-intl';
import { DashboardLink } from 'utils/link';

import BellButton from 'components/notification/bell_button';
import Logo from 'components/layout/logo';
import SpaceSelector from 'components/layout/space_selector';
import useMobile from 'hooks/use_mobile';
import useUserHeader from 'hooks/use_user_header';
import theme from 'theme';
import ProfileButton from './profile_button';

const TopMenu = ({ children }) => {
  const { sidebarVisible, setSidebarVisible } = useMenu();
  const intl = useIntl();
  const { space } = useUserHeader();
  const sidebarButtonIcon = () =>
    sidebarVisible ? <ProbelistMenuHideIcon aria-hidden="true" /> : <ProbelistMenuShowIcon aria-hidden="true" />;
  const toggleLabel = intl.formatMessage({ id: 'aria.menu.toggle' });
  const isMobile = useMobile();

  const mobileContent = () => (
    <Toolbar>
      <IconButton
        aria-label={toggleLabel}
        aria-expanded={sidebarVisible}
        aria-controls="side-menu"
        onClick={() => {
          setSidebarVisible(!sidebarVisible);
        }}
      >
        {sidebarButtonIcon()}
      </IconButton>
      {space && <Box sx={{ mr: 1 }}><SpaceSelector currentName={space.name} isMobile={isMobile} /></Box>}
      <Box sx={{ flexGrow: 1 }} />
      <BellButton />
      <ProfileButton isMobile={isMobile} />
    </Toolbar>
  );

  const desktopContent = () => (
    <Toolbar>
      <Box style={sidebarVisible ? { width: theme.width.sideMenu, display: 'flex' } : { width: 0, overflow: 'hidden' }}>
        <ButtonLink to={DashboardLink()}>
          <Logo width={40}>
            {sidebarVisible && (
              <TopMenuTitleTypography>
                <FormattedMessage id="app_name" />
              </TopMenuTitleTypography>
            )}
          </Logo>
        </ButtonLink>
      </Box>
      <Container maxWidth="xl" sx={{ display: 'flex', alignItems: 'center' }}>
        {space && <Box sx={{ mr: 1, pt: 0.5 }}><SpaceSelector currentName={space.name} /></Box>}
        {children}
        <Box sx={{ flexGrow: 1 }} />
        <BellButton />
        <ProfileButton />
      </Container>
    </Toolbar>
  );

  return (
    <>
      <StyledAppBar>{isMobile ? mobileContent() : desktopContent()}</StyledAppBar>
      {!isMobile && (
        <SidebarToggleWrapper $open={sidebarVisible}>
          <SidebarToggleButton
            aria-label={toggleLabel}
            aria-expanded={sidebarVisible}
            aria-controls="side-menu"
            onClick={() => {
              setSidebarVisible(!sidebarVisible);
            }}
          >
            {sidebarButtonIcon()}
          </SidebarToggleButton>
        </SidebarToggleWrapper>
      )}
    </>
  );
};

export default TopMenu;
